import { gsap } from 'gsap';
import { PageHandler } from './PageHandler';
import imagesLoaded from 'imagesloaded';
import { Utils } from '../misc/Utils';

export class CvPageHandler extends PageHandler {
    constructor(id) {
    	super(id);
    }

    init() {
		
		let mm = gsap.matchMedia();

		mm.add("(min-width: 769px)", () => {
			const pinElm = document.querySelector(".section-content__left img");

			const heading = document.querySelector(".section-content__left");
			gsap.to(heading, {
				scrollTrigger: {
					id: "pin",
					trigger: heading,
					start: "50% 50%",
					end: () => {
						var height2 = jQuery(heading).outerHeight();
						var top2 = window.innerHeight * 0.5 - height2/2.0;
						return `bottom 100%-=${top2}px`
					},
					endTrigger: '.section-content__right',
					pin: true,
					pinSpacing: false,
					pinType: "transform",
					invalidateOnRefresh: true
				}
			})
		})

		
    }

    ajax() {
	
	}

    destroy() {
    
    }

	events() {
		
	}

	transitions() {
		imagesLoaded( document.querySelector('.cv .section-content__left'), function (instance) {
			Utils.fadeInUp('.cv .section-content__right')
			Utils.fadeInFrom('.cv .section-content__left')
		})

	}
}